import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// Toolkit Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackReorderOrderParameters extends TrackEventBaseParameters {}

const trackReorderOrder = (parameters: TrackReorderOrderParameters, options?: Toolkit.GoogleAnalytics.Options) => {
    return ga.track.event({ action: "reorder_order", ...parameters }, options);
};

export default trackReorderOrder;
